// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_ELtnV {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border: 1px solid rgba(206, 214, 222, 1);
  border-radius: 8px;
  background-color: rgba(231, 234, 238, 1);
  flex : 1;
  min-width : 350px;
  box-sizing: border-box;
  
}

.header_qQjcJ {
  display : flex;
  align-items: center;
  border-bottom: 1px solid rgba(206, 214, 222, 1);
  width: 100%;
  height : 48px;
  font-weight: 600;
  padding-left : 16px;
  padding: 16px 10px;
  background-color: white;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.body_PTuiA {
  width : 100%;
  height : 100%;
  padding: 8px;
  height : 100%;
}

.footer_JSclQ {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 8px 8px 8px;
  background-color: rgba(231, 234, 238, 1);
  height : auto;
  border-radius: 0px 0px 8px 8px;
}

.footerCard_GGiD_ {
  display: flex;
  flex-direction: column;
  padding : 8px;
  justify-content: flex-start;
  border: 1px solid rgba(206, 214, 222, 1);
  border-radius: 8px;
  background-color: white;
  flex-grow: 1;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/lineLiveStatus/LineCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;EACxC,kBAAkB;EAClB,wCAAwC;EACxC,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;;AAExB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,+CAA+C;EAC/C,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,wCAAwC;EACxC,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,2BAA2B;EAC3B,wCAAwC;EACxC,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  border: 1px solid rgba(206, 214, 222, 1);\n  border-radius: 8px;\n  background-color: rgba(231, 234, 238, 1);\n  flex : 1;\n  min-width : 350px;\n  box-sizing: border-box;\n  \n}\n\n.header {\n  display : flex;\n  align-items: center;\n  border-bottom: 1px solid rgba(206, 214, 222, 1);\n  width: 100%;\n  height : 48px;\n  font-weight: 600;\n  padding-left : 16px;\n  padding: 16px 10px;\n  background-color: white;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n.body {\n  width : 100%;\n  height : 100%;\n  padding: 8px;\n  height : 100%;\n}\n\n.footer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 0 8px 8px 8px;\n  background-color: rgba(231, 234, 238, 1);\n  height : auto;\n  border-radius: 0px 0px 8px 8px;\n}\n\n.footerCard {\n  display: flex;\n  flex-direction: column;\n  padding : 8px;\n  justify-content: flex-start;\n  border: 1px solid rgba(206, 214, 222, 1);\n  border-radius: 8px;\n  background-color: white;\n  flex-grow: 1;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_ELtnV`,
	"header": `header_qQjcJ`,
	"body": `body_PTuiA`,
	"footer": `footer_JSclQ`,
	"footerCard": `footerCard_GGiD_`
};
export default ___CSS_LOADER_EXPORT___;
